module.exports = __webpack_public_path__ + "img/img (35).bc8b06d6.png";